import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import influencerData from '../data/influencers.json';

// // Importing images from src/assets/images
// import masoom from "../img/team-1.jpg";
// import influencer2 from "../img/team-2.jpg";
// import influencer3 from "../img/team-3.jpg";
// import influencer4 from "../img/team-4.jpg";
// import influencer5 from "../img/team-5.jpg";
// import influencer6 from "../img/team-6.jpg";
// import influencer7 from "../img/team-7.jpg";
// import influencer8 from "../img/team-8.jpg";
// import influencer9 from "../img/team-9.jpg";
// import influencer10 from "../img/team-10.jpg";
// import influencer11 from "../img/team-11.jpg";
// import influencer12 from "../img/team-12.jpg";
import Instalogo from '../img/instagram-logo.png';

const influencers = influencerData.map(influencer => ({
  ...influencer,
  category: influencer.contentCategories.primaryNiche.name.split(' & ')[0], // Extract primary category
  followers: influencer.socialMedia.followerCounts.Instagram, // Get Instagram followers
  image: influencer.influencerData.image // Get profile image
}));

const categories = [
  "All", 
  "Finance", 
  "Tech", 
  "Food", 
  "Fashion/Lifestyle", 
  "Travel", 
  "Beauty", 
  "Fitness", 
  "Edutech", 
  "Parenting", 
  "Gaming"
];

export default function InfluencerGrid() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();

  const filteredInfluencers = selectedCategory === "All"
    ? influencers
    : influencers.filter(influencer => 
        influencer.contentCategories.primaryNiche.name.includes(selectedCategory) || 
        influencer.contentCategories.secondaryNiche.name.includes(selectedCategory)
      );

  const displayedInfluencers = showAll ? filteredInfluencers : filteredInfluencers.slice(0, 4);

  const handleViewInsights = (influencer) => {
    const nameSlug = influencer.influencerData.name.toLowerCase().replace(/\s+/g, '-');
    navigate(`/insights/${influencer.id}-${nameSlug}`, {
      state: {
        influencerData: influencer
      }
    });
  };

  return (
    <div className="container-fluid mb-5 team">
      <div className="container">
        <div className="text-center mx-auto wow fadeIn" data-wow-delay=".3s" style={{ maxWidth: "600px" }}>
          <h5 className="text-primary">Our Team</h5>
          <h1>Meet our expert Team</h1>
        </div>
        <div className="teamcontainer">
          {/* Category Filters */}
          <div className="categories">
            {categories.map((category) => (
              <button
                key={category}
                className={selectedCategory === category ? "category-button active" : "category-button"}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Influencer Grid */}
          <div className="grid-container">
            {displayedInfluencers.map((influencer) => (
              <motion.div
                key={influencer.id}
                className="influencer-card"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 50 }}
                transition={{ duration: 0.5 }}
              >
                <img src={influencer.influencerData.image} alt={influencer.influencerData.name} className="influencer-image" />
                <div className="overlay">
                  <p className="name">{influencer.influencerData.name}</p>
                  <p className="category">{influencer.contentCategories.primaryNiche.name}</p>
                  <p className="followers">
                    <img src={Instalogo} alt="Instagram" className="instagram" />
                    {influencer.socialMedia.followerCounts.Instagram} Followers
                  </p>
                  <button 
                    className="insights-button"
                    onClick={() => handleViewInsights(influencer)}
                  >
                    View Insights
                  </button>
                </div>
              </motion.div>
            ))}
          </div>

          {/* View More / View Less Button */}
          {filteredInfluencers.length > 4 && (
            <motion.button
              className="view-button"
              onClick={() => setShowAll(!showAll)}
              whileHover={{ backgroundColor: "#1842b6", scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {showAll ? "VIEW LESS" : "VIEW MORE"}
            </motion.button>
          )}
        </div>
      </div>
    </div>
  );
}